import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as servicesActions from '../../actions/services/servicesActions';
import * as pendingPageActions from '../../actions/pendingPageActions';
import {bindActionCreators} from 'redux';
import moment from 'moment';


class ServiceViewContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.actions.performRequiredActions(this, [
            this.props.actions.getService(this.props.match.params.id)
        ]);
    }

    render() {
        let {
            service
        } = this.props;

        return (
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="card m-b-20">
                            <div className="card-block">
                                <h1 className="mb-3">Ydelser information</h1>

                                <table className="table table-striped table-bordered">
                                <tbody>
                                    <tr>
                                        <th>#</th>
                                        <td>{service.id}</td>
                                    </tr>
                                    <tr>
                                        <th>Overskrift</th>
                                        <td>{service.heading}</td>
                                    </tr>
                                    <tr>
                                        <th>Kontaktperson</th>
                                        <td>{(service.contactPerson) ? service.contactPerson.name : ''}</td>
                                    </tr>
                                    <tr>
                                        <th>Statistik</th>
                                        <td>{service.isStatisticAllowed.toString()}</td>
                                    </tr>
                                    <tr>
                                        <th>Offentliggøres</th>
                                        <td>{moment.unix(service.startDate).format('DD-MM-YYYY')}</td>
                                    </tr>
                                    <tr>
                                        <th>Udløber</th>
                                        <td>{moment.unix(service.endDate).format('DD-MM-YYYY')}</td>
                                    </tr>
                                    <tr>
                                        <th>Kategori</th>
                                        <td className="pl-4">
                                            {service.categories.map((category, key) => <li key={key}>{category.name}</li>)}
                                        </td>
                                    </tr>
                                    {
                                        (service.price && service.price.amount) ?
                                            <tr>
                                                <th>Pris</th>
                                                <td>{`${service.price.amount} ${service.price.currency.name} ${service.price.type.name}`}</td>
                                            </tr>
                                            : null
                                    }

                                    <tr>
                                        <th>Søges/Tilbydes</th>
                                        <td>
                                            {(service.wanted) ? 'Søges' : 'Tilbydes'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Oprettet på</th>
                                        <td>{moment.unix(service.createdAt).format('DD-MM-YYYY')}</td>
                                    </tr>
                                </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        service: state.service,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({},
            pendingPageActions,
            servicesActions
        ), dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ServiceViewContainer);


// WEBPACK FOOTER //
// ./web/src/components/services/ServiceViewContainer.jsx